import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Order, Meal } from 'src/services/classes/models/order-item';
import { CartService } from 'src/services/data/cart/cart.service';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent {
  @Input() meal: Meal;
  @Input() isSuccessPage: boolean = false;
  @Output() sendMealInfo = new EventEmitter<{ meal: Meal; action: string }>();

  orderPreference: 'dine-in' | 'takeout';
  isSelecting = false;

  constructor(private cartService: CartService) {
    // Load initial order type from home overlay selection
    const initialOrderType = localStorage.getItem('order-type');
    this.orderPreference = initialOrderType === 'TAKE_OUT' ? 'takeout' : 'dine-in';
    
    // Check if there's a saved preference that overrides the initial selection
    const savedPreference = localStorage.getItem('orderPreference');
    if (savedPreference) {
      this.orderPreference = savedPreference as 'dine-in' | 'takeout';
    }
  }

  toggleSelection() {
    this.isSelecting = true;
  }

  setPreference(preference: 'dine-in' | 'takeout') {
    this.orderPreference = preference;
    localStorage.setItem('orderPreference', preference);
    localStorage.setItem('order-type', preference === 'takeout' ? 'TAKE_OUT' : 'DINE_IN');
    this.isSelecting = false;
  }

  onActionSelection(meal: Meal, action: string) {
    this.sendMealInfo.emit({ meal, action });
  }

  onTakeoutChange() {
    this.meal.takeout = Boolean(this.meal.takeout);
    // Ensure we're updating the cart service
    this.cartService.updateCartItem(this.meal);
    this.sendMealInfo.emit({ meal: this.meal, action: 'update-takeout' });
  }

  isImageValid(control: string) {
    return /^(ftp|https|http)?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(
      control
    );
  }
}